export default __webpack_public_path__ + "static/media/ss4.e81e5b87.jpg";